import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  pop(event) {
    this.iconTargets.forEach((icon) => {
      icon.classList.remove("reaction-icon--pop")
      void icon.offsetWidth
      icon.classList.add("reaction-icon--pop")
      setTimeout(() => icon.classList.remove("reaction-icon--pop"), 200)
    })
  }
}
